import { AuthPagesEnum } from "../types/authPages.type";

export const getPageName = (path: string): string => {
  switch (path) {
    case AuthPagesEnum.DEAFAULT:
      return "Welcome to DrEvol Shop CRM";
    case AuthPagesEnum.ORDERS:
      return "Orders";
    case AuthPagesEnum.CRM_ORDERS:
      return "CRM Orders";
    case AuthPagesEnum.DISCOUNTS:
      return "Discounts";
    case AuthPagesEnum.HISTORY:
      return "History";
    case AuthPagesEnum.CLIENTS:
      return "Clients";
    case AuthPagesEnum.PRODUCTION:
      return "Productions";
    case AuthPagesEnum.PRODUCT:
      return "Products";
    case AuthPagesEnum.WAREHOUSE:
      return "Warehouse";
    case AuthPagesEnum.RESOURCES:
      return "Resources";
    case AuthPagesEnum.SUPPLEIERS:
      return "Supplier";
    case AuthPagesEnum.EMPLOYEES:
      return "Employees";
    case AuthPagesEnum.MANAGEMENT:
      return "Administrators panel";
    case AuthPagesEnum.TAGS:
      return "Сonditions";
    case AuthPagesEnum.PRODUCT_TYPES:
      return "Product types";
    case AuthPagesEnum.CATEGORIES:
      return "Categories";
    case AuthPagesEnum.BRANDS:
      return "Brands";
    case AuthPagesEnum.PRODUCTS_ORDER:
      return "Products order";
    case AuthPagesEnum.BLOGS:
      return "Blogs";
    default:
      return "Welcome to DrEvol Shop!";
  }
};
